import AOS from 'aos';
import $ from 'jquery';


/**
 * See https://github.com/michalsnik/aos
 */
export class AOSModule {
    constructor() {
        this.setAOSOnEditorcontent();

        AOS.init({
            delay: 150,
            duration: 1000,
            offset: 0,
            easing: 'ease-out-quart',
            //once: true,
        }); 
        window.addEventListener('load', () => {
            AOS.refresh();
        });
    }
    
    setAOSOnEditorcontent() {
        $(".post-content > ul li").attr('data-aos', 'fade-up');
        $(".post-content > ol li").attr('data-aos', 'fade-up');
        $(".post-content > blockquote").attr('data-aos', 'fade-up');
        $(".post-content > p").attr('data-aos', 'fade-up');
        $(".post-content > h2").attr('data-aos', 'fade-up');
        $(".post-content > h3").attr('data-aos', 'fade-up');
        $(".post-content > h4").attr('data-aos', 'fade-up');
        $(".post-content > h5").attr('data-aos', 'fade-up');
    }
}


// WEBPACK FOOTER //
// ./www/wp-content/themes/lynx-hedge/assets/scripts/src/App/AOSModule.js